import { MobileIcon, StudioPlatformIcon, WebPlatformIcon } from "icons";

export const planDuration = [
  {
    title: "1 Month",
    key: "1 Month",
    months: 1,
  },
  {
    title: "3 Months",
    key: "3 Months",
    months: 3,
  },
  {
    title: "6 Months",
    key: "6 Months",
    months: 6,
  },
  {
    title: "12 Months",
    key: "12 Months",
    months: 12,
  },
];
export const END = "end";
export const studioObj = {
  title: "Studio",
  icons: [MobileIcon, WebPlatformIcon, StudioPlatformIcon],
  icon: StudioPlatformIcon,
  bgColor: "#FFFAED",
};
export const webObj = {
  title: "Web",
  icons: [MobileIcon, WebPlatformIcon],
  icon: WebPlatformIcon,
  bgColor: "#E7FFC5",
};
export const mobileObj = {
  title: "Mobile",
  icons: [MobileIcon],
  icon: MobileIcon,
  bgColor: "#EDFDFF",
};
export const planTypes = [
  {
    title: "Basic",
    key: "basic",
    months: 3,
    subscriptionId: 2,
    platforms: [mobileObj],
  },
  {
    title: "Standard",
    key: "standard",
    months: 6,
    subscriptionId: 3,
    platforms: [mobileObj, webObj],
  },
  {
    title: "Premium",
    key: "premium",
    months: 12,
    subscriptionId: 4,
    platforms: [mobileObj, webObj, studioObj],
  },
];
